export enum MM04Direction {
    A_PLUS = 'A_PLUS',
    A_MINUS = 'A_MINUS',
    B_PLUS = 'B_PLUS',
    B_MINUS = 'B_MINUS',
    C_PLUS = 'C_PLUS',
    C_MINUS = 'C_MINUS'
}

export const MM04DirectionLabels: Record<MM04Direction, string> = {
    [MM04Direction.A_PLUS]: 'A+',
    [MM04Direction.A_MINUS]: 'A-',
    [MM04Direction.B_PLUS]: 'B+',
    [MM04Direction.B_MINUS]: 'B-',
    [MM04Direction.C_PLUS]: 'C+',
    [MM04Direction.C_MINUS]: 'C-'
};
